"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientIsBaby = void 0;
var clientIsBaby = exports.clientIsBaby = function clientIsBaby() {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname.toLowerCase().indexOf('baby.zola.com') > -1;
};